import "../tron/index.js";
import "../tron/modal.js";
//import "./checking_files/adapters.js";
//import "./checking_files/main.js";
import "./checking_files/styles1.css";
import "./checking_files/styles2.css";
//import "./checking_files/Home-3gb_NBgS.css";
import "./checking_files/css2.css";
